import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

/**
 * Thread history shape returned to the Ask Redo UI. This is a
 * simplified projection of `LlmThread` containing only fields the UI
 * needs to render the thread list + hydrate `useChat` initial
 * messages.
 */

const ThreadHistoryMessageSchema = z.object({
  id: z.string(),
  role: createEnum(["user", "assistant", "tool"]),
  content: z.union([z.string(), z.array(z.any())]),
});

export const AskRedoThreadHistorySchema = z.object({
  _id: zExt.objectId(),
  updatedAt: z.date(),
  messages: z.array(MessageSchema),
  // A short preview derived from the most recent user message (used
  // in the thread list sidebar).
  preview: z.string().optional(),
});

export const getAskRedoThreads = {
  name: "getAskRedoThreads" as const,
  input: z.object({
    userEmail: z.string().email().describe("User email to filter threads by"),
  }),
  output: z.object({ threads: z.array(AskRedoThreadHistorySchema) }),
};

export const getAskRedoThread = {
  name: "getAskRedoThread" as const,
  input: z.object({ threadId: zExt.objectId() }),
  output: z.object({
    thread: z.object({
      _id: zExt.objectId(),
      updatedAt: z.date(),
      messages: z.array(MessageSchema),
    }),
  }),
};

export type { ThreadHistoryMessageSchema };
